import { SxProps, Theme } from '@mui/material';
import { AI_GRADIENT_CSS } from 'common/constants/ai';

export const PILL_HALF_WIDTH = 24;
export const PILL_DIVIDER_WIDTH = 1;
export const PILL_WIDTH = PILL_HALF_WIDTH * 2 + PILL_DIVIDER_WIDTH;
export const PILL_HEIGHT = 20;
export const PILL_GAP_ABOVE_CELL = 4;

export const pillRootSx: SxProps<Theme> = {
  position: 'absolute',
  display: 'flex',
  alignItems: 'stretch',
  width: `${PILL_WIDTH}px`,
  height: `${PILL_HEIGHT}px`,
  borderRadius: `${PILL_HEIGHT / 2}px`,
  overflow: 'hidden',
  background: AI_GRADIENT_CSS,
  boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
  zIndex: 10,
  pointerEvents: 'auto',
  userSelect: 'none',
};

export const pillHalfSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  color: 'white',
  border: 'none',
  outline: 'none',
  background: 'transparent',
  cursor: 'pointer',
  padding: 0,
  '& svg': {
    fontSize: 14,
  },
  '&:hover': {
    background: 'rgba(255,255,255,0.18)',
  },
  '&:disabled': {
    opacity: 0.6,
    cursor: 'default',
  },
};

export const pillDividerSx: SxProps<Theme> = {
  width: '1px',
  alignSelf: 'stretch',
  background: 'rgba(255,255,255,0.5)',
};
